import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"margin":"1em 0"} }
const _hoisted_2 = { class: "step" }

import AddressField from '@/components/common/AddressField.vue';
import RichTextFieldSmall from '@/components/common/RichTextFieldSmall.vue';
import { Step, Action } from '@/models/action.model';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StepsField',
  props: {
  modelValue: {
    type: Object as PropType<Step[]>,
    required: true,
  },
  action: {
    type: Object as PropType<Action>,
    required: true,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const steps = ref<Step[]>([
  ...(props.modelValue || []).sort((a, b) => a.index - b.index),
]);

const emit = __emit;

function update() {
  emit('update:modelValue', steps);
  emit('change');
}

function addStep() {
  steps.value.push({
    description: '',
    index: steps.value.length,
    address: {
      street: '',
      house_number: '',
      postal_code: '',
      city: '',
      country: 'NL',
    },
  });
  update();
}

function removeStep(index: number) {
  steps.value.splice(index, 1);
  update();
}

function moveUp(answer: Step) {
  const index = steps.value.findIndex((a) => a.id === answer.id);

  steps.value = [
    ...steps.value.slice(0, index - 1),
    answer,
    steps.value[index - 1],
    ...steps.value.slice(index + 1),
  ].map((v, index) => ({ ...v, index }));

  update();
}

function moveDown(answer: Step) {
  const index = steps.value.findIndex((a) => a.id === answer.id);

  steps.value = [
    ...steps.value.slice(0, index),
    steps.value[index + 1],
    answer,
    ...steps.value.slice(index + 2),
  ].map((v, index) => ({ ...v, index }));

  update();
}

watch(
  () => props.modelValue,
  () => {
    Object.assign(steps.value, props.modelValue);
  },
  { deep: true },
);

const showDetails = ref<{ [index: number]: boolean }>({});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Steps", -1)),
    _createVNode(_component_v_list, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...steps.value].sort((a, b) => a.index - b.index), (step, index) => {
          return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_text_field, {
                  modelValue: step.description,
                  "onUpdate:modelValue": ($event: any) => ((step.description) = $event),
                  label: "Description",
                  placeholder: `Step ${index + 1}`,
                  "append-icon": 
              showDetails.value[index]
                ? 'mdi-menu-up-outline'
                : 'mdi-menu-down-outline'
            ,
                  "onClick:append": ($event: any) => (showDetails.value[index] = !showDetails.value[index]),
                  required: "",
                  "hide-details": "auto",
                  onChange: update
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "append-icon", "onClick:append"]),
                _cache[0] || (_cache[0] = _createTextVNode("   ")),
                _createVNode(RichTextFieldSmall, {
                  text: steps.value[index].description,
                  onChange: (v) => (step.description = v),
                  styles: "position: relative; top: 10px; left: 8px"
                }, null, 8, ["text", "onChange"]),
                _cache[1] || (_cache[1] = _createTextVNode("   ")),
                _createVNode(_component_v_btn, {
                  icon: "mdi-arrow-up",
                  class: "remove-button",
                  density: "compact",
                  disabled: index === 0 || step.id === undefined,
                  onClick: _withModifiers(($event: any) => (moveUp(step)), ["prevent"])
                }, null, 8, ["disabled", "onClick"]),
                _cache[2] || (_cache[2] = _createTextVNode("   ")),
                _createVNode(_component_v_btn, {
                  icon: "mdi-arrow-down",
                  class: "remove-button",
                  density: "compact",
                  disabled: index === steps.value.length - 1 || step.id === undefined,
                  onClick: _withModifiers(($event: any) => (moveDown(step)), ["prevent"])
                }, null, 8, ["disabled", "onClick"]),
                _cache[3] || (_cache[3] = _createTextVNode("   ")),
                _createVNode(_component_v_btn, {
                  icon: "mdi-delete-outline",
                  class: "remove-button",
                  density: "compact",
                  onClick: _withModifiers(($event: any) => (removeStep(index)), ["prevent"])
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", null, [
                (step.address.street)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      density: "compact",
                      class: "mt-2 ml-4",
                      color: "warning"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("Filtered on location")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              (showDetails.value[index])
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 0,
                    class: "step-details",
                    elevation: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AddressField, {
                        modelValue: step.address,
                        "onUpdate:modelValue": ($event: any) => ((step.address) = $event),
                        onChange: update
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_v_btn, { onClick: addStep }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [
        _createTextVNode("Add Step")
      ])),
      _: 1
    })
  ]))
}
}

})